import { extractPaginationInfo } from '@/utils/pagination-util'
export const mutations = {}